/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskAylienNewsDetailsEntry
 */
export interface ExecRiskAylienNewsDetailsEntry {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    snippet?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    overall_sentiment?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    positive?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    neutral?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    negative?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    canonical_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    author?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    article_body?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    date_published?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    date_modified?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    authors?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    triggers: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAylienNewsDetailsEntry
     */
    triggers_count?: number;
}

/**
 * Check if a given object implements the ExecRiskAylienNewsDetailsEntry interface.
 */
export function instanceOfExecRiskAylienNewsDetailsEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "triggers" in value;

    return isInstance;
}

export function ExecRiskAylienNewsDetailsEntryFromJSON(json: any): ExecRiskAylienNewsDetailsEntry {
    return ExecRiskAylienNewsDetailsEntryFromJSONTyped(json, false);
}

export function ExecRiskAylienNewsDetailsEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskAylienNewsDetailsEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'snippet': !exists(json, 'snippet') ? undefined : json['snippet'],
        'overall_sentiment': !exists(json, 'overall_sentiment') ? undefined : json['overall_sentiment'],
        'positive': !exists(json, 'positive') ? undefined : json['positive'],
        'neutral': !exists(json, 'neutral') ? undefined : json['neutral'],
        'negative': !exists(json, 'negative') ? undefined : json['negative'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'canonical_url': !exists(json, 'canonical_url') ? undefined : json['canonical_url'],
        'author': !exists(json, 'author') ? undefined : json['author'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'article_body': !exists(json, 'article_body') ? undefined : json['article_body'],
        'date_published': !exists(json, 'date_published') ? undefined : json['date_published'],
        'date_modified': !exists(json, 'date_modified') ? undefined : json['date_modified'],
        'authors': !exists(json, 'authors') ? undefined : json['authors'],
        'triggers': json['triggers'],
        'triggers_count': !exists(json, 'triggers_count') ? undefined : json['triggers_count'],
    };
}

export function ExecRiskAylienNewsDetailsEntryToJSON(value?: ExecRiskAylienNewsDetailsEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'snippet': value.snippet,
        'overall_sentiment': value.overall_sentiment,
        'positive': value.positive,
        'neutral': value.neutral,
        'negative': value.negative,
        'url': value.url,
        'canonical_url': value.canonical_url,
        'author': value.author,
        'language': value.language,
        'article_body': value.article_body,
        'date_published': value.date_published,
        'date_modified': value.date_modified,
        'authors': value.authors,
        'triggers': value.triggers,
        'triggers_count': value.triggers_count,
    };
}

